import { Bug, Send } from 'lucide-react'
import { Button } from '@teach/ui'
import { ResponsiveDialog } from '@/components/common/ResponsiveDialog'
import { SUPPORT_BOT_URL } from './supportLinks'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * «Нашли баг?»: на ПК — окно, на телефоне — шторка снизу (`ResponsiveDialog`).
 * Сам отчёт живёт в Telegram-боте поддержки — там автор пишет подробно и
 * прикладывает скриншоты; студия только зовёт туда.
 */
export const ReportBugDialog = ({ open, onOpenChange }: Props) => {
  const m = useMessages(messages)
  return (
    <ResponsiveDialog
      open={open}
      onOpenChange={onOpenChange}
      title={m.dialogTitle}
      description={<p className="text-sm text-muted-foreground">{m.dialogBody}</p>}
      className="max-w-md"
    >
      <div className="flex flex-col items-center gap-5 pt-2">
        <div className="flex size-16 items-center justify-center rounded-full bg-brand/15 text-brand">
          <Bug className="size-8" />
        </div>
        <Button asChild size="lg" className="w-full">
          <a
            href={SUPPORT_BOT_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onOpenChange(false)}
          >
            <Send />
            {m.openBot}
          </a>
        </Button>
      </div>
    </ResponsiveDialog>
  )
}
